import React, { useCallback, useEffect } from 'react';
import { initAsyncProcess, initSyncProcess } from './services/init/init-app.service';
import { useBoundStore } from './store';
import { buildNavigationStack } from './services';
import { SplashScreen } from '@Components/splash/SplashScreen';
import { RouterProvider } from '@tanstack/react-router';
import { router } from '@Routes/__root';
import { AppStateTypes } from '@Types/onboarding.types';
import { RouteTrackerProvider } from '@Providers/RouteTrackerProvider/RouteTrackerProvider';

const App = () => {
  const { setAppState, appState } = useBoundStore((state) => state.onboardingSlice);

  const initAppLoadProcess = useCallback(async () => {
    initSyncProcess();
    try {
      await initAsyncProcess();
      await buildNavigationStack({});
    } catch (error) {
      console.error('Error initializing app', error);
    }
    setAppState(AppStateTypes.READY);
  }, [setAppState]);

  useEffect(() => {
    initAppLoadProcess();
  }, [initAppLoadProcess]);

  return (
    <>
      {appState === AppStateTypes.PRELOAD && <SplashScreen />}
      {(appState === AppStateTypes.READY || appState === AppStateTypes.LOADING) && (
        <RouteTrackerProvider>
          <RouterProvider router={router} />
        </RouteTrackerProvider>
      )}
    </>
  );
};

export default React.memo(App);
